export function isBotUserAgent() {

    const agent = window?.navigator?.userAgent || "";

    const botUserAgentsArray = [
        'googlebot',
        'bingbot',
        'linkedinbot',
        'mediapartners-google',
        'lighthouse',
        'insights',
        'crawler',
        'prerender',
        'SEO crawler'
    ];

    var isBotUserAgent = 0;
    for (var j = 0; j < botUserAgentsArray.length; j++) {
        if (agent.toLowerCase().indexOf(botUserAgentsArray[j].toLowerCase()) !== -1) {
            isBotUserAgent = 1;
            break;
        }
    }

    return isBotUserAgent;
}

if (isBotUserAgent()) {
    window.alert = () => { };
}

export function canTrack() {
    return !isBotUserAgent() && window.location.hostname != 'localhost' && window.location.hostname != '127.0.0.1';
}